var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5168 69.375L20.6585 59.5083L9.5585 57.0417L10.6377 45.6333L3.0835 37L10.6377 28.3667L9.5585 16.9583L20.6585 14.4917L26.5168 4.625L37.0002 9.09583L47.4835 4.625L53.3418 14.4917L64.4418 16.9583L63.3627 28.3667L70.9168 37L63.3627 45.6333L64.4418 57.0417L53.3418 59.5083L47.4835 69.375L37.0002 64.9042L26.5168 69.375ZM33.7627 47.9458L51.1835 30.525L46.8668 26.0542L33.7627 39.1583L27.1335 32.6833L22.8168 37L33.7627 47.9458Z",
    fill: "#0F9918"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success-check.dd0530ddfa7a573857c55d4d10e2be20.svg";
export { ForwardRef as ReactComponent };